import { type FC } from 'react'

import { Skeleton } from '@/components/ui/skeleton.tsx'
import { classNames } from '@/utils/helpers.ts'

export const VaultMediaSkeleton: FC<{ isForSelection: boolean }> = ({
  isForSelection,
}) => {
  return (
    <>
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
      <VaultMediaSkeletonItem isForSelection={isForSelection} />
    </>
  )
}

const VaultMediaSkeletonItem: FC<{ isForSelection: boolean }> = ({
  isForSelection,
}) => (
  <Skeleton
    className={classNames(
      'relative aspect-square overflow-hidden dark:bg-neutral-800',
      {
        'w-full rounded pt-[calc((100%-8px)/4)]': isForSelection,
        'w-full pt-[calc((100%-4px)/3)]': !isForSelection,
      },
    )}
  />
)
